import React from "react";
import { User, Award, Briefcase } from "lucide-react";
import { portfolioData } from "../data/mock";

const About = () => {
  const { about } = portfolioData;

  return (
    <section id="about" className="py-20 bg-slate-800/50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="bg-gradient-to-r from-cyan-400 to-violet-500 bg-clip-text text-transparent">
              {about.title}
            </span>
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto">
            {about.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-6">
              <p className="text-lg text-slate-300 leading-relaxed">
                {about.description}
              </p>
            </div>

            {/* Skills */}
            <div>
              <h3 className="text-xl font-semibold text-white mb-4 flex items-center">
                <Briefcase className="text-cyan-400 mr-2" size={20} />
                Mes compétences
              </h3>
              <div className="grid grid-cols-2 gap-3">
                {about.skills.map((skill, index) => (
                  <div
                    key={index}
                    className="bg-slate-700/50 px-4 py-2 rounded-lg text-slate-300 hover:bg-slate-700 transition-colors duration-300"
                  >
                    {skill}
                  </div>
                ))}
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6">
              <div className="text-center p-6 bg-gradient-to-br from-cyan-500/10 to-violet-500/10 rounded-xl border border-slate-700">
                <div className="text-3xl font-bold bg-gradient-to-r from-cyan-400 to-violet-500 bg-clip-text text-transparent mb-2">
                  {about.experience}
                </div>
                <div className="text-slate-400 text-sm">d'expérience</div>
              </div>
              <div className="text-center p-6 bg-gradient-to-br from-violet-500/10 to-pink-500/10 rounded-xl border border-slate-700">
                <div className="text-3xl font-bold bg-gradient-to-r from-violet-400 to-pink-400 bg-clip-text text-transparent mb-2">
                  {about.projects}
                </div>
                <div className="text-slate-400 text-sm">projets réalisés</div>
              </div>
            </div>
          </div>

          {/* Right Content - Image/Visual */}
          <div className="relative">
            <div className="relative z-10">
              <div className="bg-gradient-to-br from-slate-800 to-slate-900 p-8 rounded-2xl border border-slate-700 shadow-2xl">
                <div className="space-y-6">
                  <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-gradient-to-r from-cyan-500 to-violet-500 rounded-full overflow-hidden flex items-center justify-center">
                      <img 
                        src="https://via.placeholder.com/64x64/06b6d4/ffffff?text=M" 
                        alt="Mike - Web Key Studio" 
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'flex';
                        }}
                      />
                      <User className="text-white" size={32} style={{display: 'none'}} />
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-white">Mike</h3>
                      <p className="text-slate-400">Développeur Web Freelance</p>
                    </div>
                  </div>
                  
                  <div className="space-y-4">
                    <div className="flex items-center space-x-3">
                      <Award className="text-cyan-400" size={16} />
                      <span className="text-slate-300">Expert Angular & Symfony</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <Award className="text-violet-400" size={16} />
                      <span className="text-slate-300">Spécialiste WordPress</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <Award className="text-pink-400" size={16} />
                      <span className="text-slate-300">Designer UI/UX</span>
                    </div>
                  </div>

                  <div className="pt-4 border-t border-slate-700">
                    <p className="text-slate-400 text-sm italic">
                      "Transformer vos idées en solutions digitales innovantes"
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Background decoration */}
            <div className="absolute -top-4 -right-4 w-72 h-72 bg-gradient-to-r from-cyan-500/10 to-violet-500/10 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-4 -left-4 w-48 h-48 bg-gradient-to-r from-violet-500/10 to-pink-500/10 rounded-full blur-3xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;